import $x from '@/utils/$x';

/**
 * 查询实体商品列表
 * @param {*} params
 * @returns
 */
export async function queryPhysicalGoodsList(params) {
  return $x.post('/pergamonGoods/queryPhysicalGoodsList', params);
}

/**
 * 删除实体商品
 * @param params
 * @returns {Promise<*>}
 */
export async function deletePhysicalGoods(params) {
  return $x.post('/pergamonGoods/deletePhysicalGoods', params);
}
